import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { ExternalLink } from '../../external-link'
import { Link } from 'react-router-dom'

export const MobileMenuItem = forwardRef(
  ({ as = 'button', children, className, path, onClose, ...rest }, ref) => {
    const Comp = as

    if (path) {
      if (path.startsWith('https://')) {
        return (
          <ExternalLink
            className={className}
            target="_self"
            href={path}
            style={{ padding: '0 0.5rem' }}
          >
            {children}
          </ExternalLink>
        )
      }
      return (
        <Link
          className={className}
          style={{ padding: '0 0.5rem' }}
          to={path}
          onClick={onClose}
        >
          {children}
        </Link>
      )
    }

    return (
      <Comp className={className} ref={ref} {...rest}>
        {children}
      </Comp>
    )
  },
)

MobileMenuItem.displayName = 'MobileMenuItem'
MobileMenuItem.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  path: PropTypes.string,
  onClose: PropTypes.func,
}
